<template>
  <v-container fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="returnSettingsData"
        :options.sync="options"
        item-key="id"
        :footer-props="footerProps"
        :loading-text="$t('return.settings.settingsLoading')"
        :no-data-text="$t('return.settings.noSettings')"
        mobile-breakpoint="768"
        :loading="loadingData"
        :server-items-length="totalReturnsSettings"
        dense
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat class="my-1">
            <v-row v-if="$vuetify.breakpoint.width >= 520" no-gutters align="center">
              <v-col cols="7" md="7" xl="6" class="pr-2">
                <countries-autocomplete
                  v-model="selectedCountries"
                  :label="$t('return.settings.countryCode')"
                  clearable
                  dense
                  hide-details
                  outlined
                  multiple
                  @blur="reloadList"
                  @click:clear="reloadList"
                ></countries-autocomplete>
              </v-col>
              <v-col cols="auto">
                <v-btn :to="'/returns-settings/add'" color="primary" outlined><v-icon>mdi-plus</v-icon></v-btn>
                <v-badge overlap :value="nbActiveFilters" :content="nbActiveFilters">
                  <v-btn color="primary" outlined class="ml-2" @click="displayFilters = !displayFilters">
                    <v-icon>mdi-filter-plus-outline</v-icon>
                  </v-btn>
                </v-badge>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="reloadList()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-toolbar v-if="$vuetify.breakpoint.width < 520" flat class="my-1">
            <countries-autocomplete
              v-model="selectedCountries"
              :label="$t('return.settings.countryCode')"
              clearable
              dense
              hide-details
              outlined
              multiple
              class="mr-2 flex-fill-min"
              @blur="reloadList"
              @click:clear="reloadList"
            ></countries-autocomplete>
            <v-btn :to="'/returns-settings/add'" color="primary" outlined><v-icon>mdi-plus</v-icon></v-btn>
            <v-badge overlap :value="nbActiveFilters" :content="nbActiveFilters">
              <v-btn color="primary" outlined class="ml-2" @click="displayFilters = !displayFilters">
                <v-icon>mdi-filter-plus-outline</v-icon>
              </v-btn>
            </v-badge>
          </v-toolbar>
        </template>

        <template v-slot:item.default_settings="{ item }">
          <v-icon>
            {{ item.default_settings ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </template>

        <template v-slot:item.country_code="{ item }">
          <span v-if="item.country_code">{{ item.country_code }}</span>
          <v-icon v-else>
            {{ 'mdi-close' }}
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 768 ? '' : 'pr-0']"
            text
            color="primary"
            @click="viewDetails(item._id)"
          >
            {{ $t('return.settings.details') }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <filter-dialog
      :key="formFiltersKey"
      v-model="displayFilters"
      :fields="formFilters"
      :loadingData="loadingData"
      :title="$t('return.settings.filtersSettings')"
      @confirm="filter"
    ></filter-dialog>
  </v-container>
</template>
<script>
  import { EventBus } from '@/event-bus'
  import { mapState } from 'vuex'
  import CountriesAutocomplete from '../../components/CountriesAutocomplete.vue'

  export default {
    name: 'ReturnSettingsTable',
    components: { CountriesAutocomplete },
    data() {
      return {
        returnSettingsData: [],
        formFiltersKey: Date.now(),
        options: {
          itemsPerPage: 15,
          sortDesc: [],
        },
        loadingData: true,
        totalReturnsSettings: 0,
        filters: [],
        displayFilters: false,
        selectedCountries: [],
      }
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    computed: {
      ...mapState(['currentStore', 'isCustomerService', 'roleRights']),

      nbActiveFilters() {
        return this.filters.filter((filter) => filter.active).length
      },
      status() {
        return [
          { text: this.$t('return.settings.enabled'), value: true },
          { text: this.$t('return.settings.disabled'), value: false },
        ]
      },
      headers() {
        return [
          {
            text: this.$t('return.settings.reference'),
            value: '_id',
            filterType: 'text',
            sortable: true,
          },
          {
            text: this.$t('return.settings.defaultSettings'),
            value: 'default_settings',
            sortable: false,
          },
          {
            text: this.$t('return.settings.countryCode'),
            value: 'country_code',
            filterType: 'text',
            sortable: true,
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ]
      },
      formFilters() {
        return [
          {
            text: this.$t('return.settings.defaultSettings'),
            value: 'default_settings',
            filterType: 'checkbox',
          },
        ]
      },
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('return.returnsPerPage'),
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('return.sortByText'),
        }
      },
    },
    methods: {
      filter(filters) {
        this.filters = filters
        this.reloadList()
      },
      viewDetails: function (id) {
        this.$router.push({ name: 'ReturnSettingsEdit', params: { id: id } })
      },
      async reloadList() {
        await this.$auth.isAuthenticated()
        this.options.page = 1
        this.list()
      },
      list() {
        this.loadingData = true

        let { page, itemsPerPage, sortDesc, sortBy } = this.options

        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy.length === 0 ? 'country_code' : sortBy,
            sortDesc: sortDesc.length === 0 ? true : sortDesc,
          },
        }

        let filters = {}
        for (let filter of this.filters) {
          if (filter.active) {
            filters[filter.name] = filter.value
          }
        }
        if (this.selectedCountries.length > 0) {
          filters.countries = this.selectedCountries
        }

        if (Object.entries(filters).length !== 0) {
          myInit.queryStringParameters.filters = JSON.stringify(filters)
        }

        this.$Amplify.API.get('returns', '/v1/int/settings', myInit)
          .then((res) => {
            this.returnSettingsData = res.data
            this.totalReturnsSettings = res.nbReturnsSettings
            if (this.totalReturnsSettings < (this.options.page - 1) * this.options.itemsPerPage + 1) {
              let pageNumber = Math.floor(this.totalReturnsSettings / this.options.itemsPerPage)
              this.options.page = pageNumber === 0 ? 1 : pageNumber
            }
            this.loadingData = false
          })
          .catch((e) => {
            this.loadingData = false
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('return.settings.loadingError'),
              color: 'error',
            })
          })
      },
    },
    activated() {
      let previousPath = this.$store.state.previousPath.split('/')[1]
      // we reset filters if the previous page wasn't the details of an order of the table OR if vue recycled it from a different instance
      if (previousPath !== 'returns-settings') {
        this.formFiltersKey = Date.now()
        this.filters = []
        this.selectedCountries = []
        this.options.itemsPerPage = 15
        this.options.page = 1
        this.options.sortBy = []
        this.options.sortDesc = []
      }
      this.returnSettingsData = []
      this.list()
    },
  }
</script>

<style scoped>
.flex-fill-min {
  flex: 1;
  min-width: 0;
}
</style>
